import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { firstValueFrom } from 'rxjs';
import { first } from 'rxjs/operators';
import { selectCurrentPerson } from '@app-store/app-session/app-session.selectors';
import { AccessRole } from '@alcon-db-models/Enums';

@Injectable({
  providedIn: 'root'
})
export class ExpenseTypeService {
  expenseTypes: any[] = []; 
  showExpenseNotice: boolean = false;

 constructor(private store: Store) {}

  async hasAccess(): Promise<boolean> {
    const person = await firstValueFrom(
      this.store.select(selectCurrentPerson).pipe(first())
    );    
    const rolesToCheck = [
      AccessRole.AcbAdmin,
      AccessRole.Corporate,
      AccessRole.AdminRoles
    ];
    return person?.accessRoles?.some(role => rolesToCheck.includes(role as AccessRole)) ?? false;
  }
 
  addExpenseTypes(type: any) {
    if (type == null) return;

    const values = Array.isArray(type)
      ? type
      : typeof type === 'string'
        ? type
            .trim()
            .replace(/^\[|\]$/g, '')
            .split(',')
            .map((value: string) => value.trim())
            .filter((value: string) => value !== '')
        : [type];

    this.expenseTypes = [...this.expenseTypes, ...values];
  }

  getExpenseTypes() {
    return this.expenseTypes;
  }
  
  hasMultipleDifferentExpenseTypes(expenseTypes: any[] = this.expenseTypes): boolean {
    const values = (expenseTypes ?? [])
      .map((t: any) => (t && typeof t === 'object') ? (t.expenseType ?? JSON.stringify(t)) : t)
      .filter((t: any) => t != null && t !== '');

    if (values.length <= 1) {
      return false;
    }

    return new Set(values).size > 1;
  }

  public onCheckExpenseDelete(whichOne: any[] = []) {
    const remainingExpenseTypes = (whichOne ?? [])
      .map((item: any) => item?.fund?.expenseType ?? item?.expenseType)
      .filter((value: any) => value != null && value !== '');

    this.expenseTypes = remainingExpenseTypes;
    this.showExpenseTypeVisible(this.hasMultipleDifferentExpenseTypes(remainingExpenseTypes));
  }
  
public onCheckExpenseNotice() {
  const count = this.getExpenseTypes().length;

  this.hasAccess().then((hasAccess) => {
    if (!hasAccess) {      
      if (count === 1) {
        this.showExpenseTypeVisible(false);
      } else if (this.hasMultipleDifferentExpenseTypes()) {
        this.showExpenseTypeVisible(true);
      } else {
        this.showExpenseTypeVisible(false);
      }
    } else {
      this.showExpenseTypeVisible(false);
    }
  });
}
  showExpenseTypeVisible(show: boolean): void {
    this.showExpenseNotice = show;
  }

  get showExpenseTypeMismatch(): boolean {
    return this.expenseTypes?.length > 1 && this.hasMultipleDifferentExpenseTypes();
  }
}